module.exports = __webpack_public_path__ + "img/Logo-13.95c0cb4c.svg";